import { render, staticRenderFns } from "./defectForm.vue?vue&type=template&id=55e8d23c&scoped=true"
import script from "./defectForm.vue?vue&type=script&lang=js"
export * from "./defectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e8d23c",
  null
  
)

export default component.exports